module.exports = __webpack_public_path__ + "static/images/smartspot-performance-da.a3f73fc590f0dad6c5b025fbf59785d4.png";